import { updatePhoneNumberAction } from 'components/Profile/store'
import { connect } from 'react-redux'
import UI from './UI'

const mapDispatchToProps = dispatch => ({
  updatePhoneNumber: (phoneNumber) => dispatch(updatePhoneNumberAction(phoneNumber))
})

export default connect(null, mapDispatchToProps)(UI)
